import styled from 'styled-components';

export const ContentContainer = styled.div`
  font: ${(props) => props.theme.fonts.textBigHeight24};
  color: ${(props) => props.theme.colors.greys.darker};
`;
